module.exports = __webpack_public_path__ + "img/dea-formazione-ico-francese.49b7bd1d.svg";